import React from 'react';

/**
 * Route-level error boundary (V.20): a render or teardown error shows a recovery message
 * instead of a blank white page. `resetKey` clears the error when the route changes.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Route crashed:', error, info?.componentStack);
  }

  componentDidUpdate(prevProps) {
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ error: null });
    }
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div role="alert" style={{ minHeight: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 12, padding: 24, textAlign: 'center' }}>
        <p style={{ opacity: 0.7, maxWidth: 420 }}>This page hit an unexpected error. Your data is safe.</p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{ padding: '8px 16px', borderRadius: 6, border: '1px solid currentColor', cursor: 'pointer', background: 'transparent', color: 'inherit' }}
        >
          Something went wrong — reload
        </button>
      </div>
    );
  }
}
